"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridRange = void 0;
const grid_js_1 = require("@ngageoint/grid-js");
const MGRSUtils_1 = require("../MGRSUtils");
const BandLetterRange_1 = require("./BandLetterRange");
const GridZones_1 = require("./GridZones");
const ZoneNumberRange_1 = require("./ZoneNumberRange");
/**
 * Grid Range
 */
class GridRange {
    /**
     * Constructor
     *
     * @param zoneNumberRange
     *            zone number range
     * @param bandLetterRange
     *            band letter range
     */
    constructor(zoneNumberRange = new ZoneNumberRange_1.ZoneNumberRange(), bandLetterRange = new BandLetterRange_1.BandLetterRange()) {
        /**
         * Additional special case grid zones
         */
        this.additional = [];
        this.zoneNumberRange = zoneNumberRange;
        this.bandLetterRange = bandLetterRange;
        this.minZoneNumber = zoneNumberRange.getWest();
        this.maxZoneNumber = zoneNumberRange.getEast();
        this.minBandLetter = bandLetterRange.getSouth();
        this.maxBandLetter = bandLetterRange.getNorth();
        this.zoneNumber = this.minZoneNumber;
        this.bandLetter = this.minBandLetter;
    }
    /**
     * Get the zone number range
     *
     * @return zone number range
     */
    getZoneNumberRange() {
        return this.zoneNumberRange;
    }
    /**
     * Set the zone number range
     *
     * @param zoneNumberRange
     *            zone number range
     */
    setZoneNumberRange(zoneNumberRange) {
        this.zoneNumberRange = zoneNumberRange;
    }
    /**
     * Get the band letter range
     *
     * @return band letter range
     */
    getBandLetterRange() {
        return this.bandLetterRange;
    }
    /**
     * Set the band letter range
     *
     * @param bandLetterRange
     *            band letter range
     */
    setBandLetterRange(bandLetterRange) {
        this.bandLetterRange = bandLetterRange;
    }
    /**
     * Get the grid range bounds
     *
     * @return bounds
     */
    getBounds() {
        const west = this.zoneNumberRange.getWestLongitude();
        const south = this.bandLetterRange.getSouthLatitude();
        const east = this.zoneNumberRange.getEastLongitude();
        const north = this.bandLetterRange.getNorthLatitude();
        return grid_js_1.Bounds.degrees(west, south, east, north);
    }
    next() {
        while (!this.gridZone && this.zoneNumber <= this.maxZoneNumber) {
            this.gridZone = GridZones_1.GridZones.getGridZone(this.zoneNumber, this.bandLetter);
            // Handle special case grid gaps (Svalbard)
            if (!this.gridZone) {
                // Retrieve the western grid if on the left edge
                if (this.zoneNumber === this.minZoneNumber) {
                    this.additional.push(GridZones_1.GridZones.getGridZone(this.zoneNumber - 1, this.bandLetter));
                }
                // Expand to the eastern grid if on the right edge
                if (this.zoneNumber === this.maxZoneNumber) {
                    this.additional.push(GridZones_1.GridZones.getGridZone(this.zoneNumber + 1, this.bandLetter));
                }
            }
            else {
                // Handle special case grid zone expansions (Norway)
                const expand = this.gridZone.getStripExpand();
                if (expand !== 0) {
                    if (expand > 0) {
                        for (let expandZone = this.zoneNumber + expand; expandZone > this.zoneNumber; expandZone--) {
                            if (expandZone > this.maxZoneNumber) {
                                this.additional.push(GridZones_1.GridZones.getGridZone(expandZone, this.bandLetter));
                            }
                            else {
                                break;
                            }
                        }
                    }
                    else {
                        for (let expandZone = this.zoneNumber + expand; expandZone < this.zoneNumber; expandZone++) {
                            if (expandZone < this.minZoneNumber) {
                                this.additional.push(GridZones_1.GridZones.getGridZone(expandZone, this.bandLetter));
                            }
                            else {
                                break;
                            }
                        }
                    }
                }
            }
            this.bandLetter = MGRSUtils_1.MGRSUtils.nextBandLetter(this.bandLetter);
            if (this.bandLetter > this.maxBandLetter) {
                this.zoneNumber++;
                this.bandLetter = this.minBandLetter;
            }
        }
        if (!this.gridZone && this.additional.length > 0) {
            this.gridZone = this.additional.shift();
        }
        if (this.gridZone) {
            const result = this.gridZone;
            this.gridZone = undefined;
            return {
                done: false,
                value: result,
            };
        }
        else
            return {
                done: true,
                value: null,
            };
    }
    reset() {
        this.zoneNumber = this.minZoneNumber;
        this.bandLetter = this.minBandLetter;
    }
    [Symbol.iterator]() {
        return this;
    }
}
exports.GridRange = GridRange;
//# sourceMappingURL=GridRange.js.map